import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
  faTshirt,
  faShoePrints,
  faGem,
  faLayerGroup,
  faHeadset,
  faMapMarkerAlt,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Section from '../ui/Section/Section';
import './AboutSection.css';

const AboutSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const segments = [
    {
      icon: faTshirt,
      title: 'Lojas de Roupas',
      description:
        'Sistema especialista em lojas de confecções, com foco em performance de vendas, gestão de condicional (bag delivery) e controle inteligente para varejo de moda.',
    },
    {
      icon: faShoePrints,
      title: 'Lojas de Calçados',
      description:
        'Solução ideal para lojas de calçados, com gestão inteligente de numeração por cliente e tecnologia com IA que sugere produtos conforme o perfil de compra.',
    },
    {
      icon: faGem,
      title: 'Lojas de Acessórios',
      description:
        'Gestão eficiente para lojas de acessórios, controle ágil e inteligência de vendas para aumentar o ticket médio e evitar falta de produtos.',
    },
    {
      icon: faLayerGroup,
      title: 'Plataforma para Redes de Varejo',
      description:
        'Gestão centralizada para redes multimarcas e franquias, com visão consolidada das operações, controle integrado entre filiais e tomada de decisão baseada em dados.',
    },
    {
      icon: faHeadset,
      title: 'Suporte Ágil',
      description:
        'Atendimento rápido e humanizado para resolver suas dúvidas e garantir a continuidade do seu negócio sem interrupções.',
    },
    {
      icon: faMapMarkerAlt,
      title: '100% do Território Nacional',
      description:
        'Atendemos lojas de norte a sul do Brasil com suporte remoto e total cobertura nacional, onde quer que você esteja.',
    },
  ];

  /* Bloquear scroll do body quando modal está aberto */
  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isModalOpen]);

  useEffect(() => {
    if (!isModalOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsModalOpen(false);
      }
    };

    window.addEventListener('keydown', handleEscape);

    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isModalOpen]);

  return (
    <>
      <Section
        id="sobre-nos"
        subtitle="CONHEÇA A INFORMEZZ"
        title="Experiência e inovação para fazer sua loja crescer"
        description="Há mais de duas décadas, impulsionamos a gestão de lojas de roupas e calçados com tecnologia de ponta e soluções desenvolvidas para atender às necessidades reais do varejo."
        centered
        background="gradient"
      >
        {/* Segmentos */}
        <div className="about__values">
          {segments.map((item, index) => (
            <div key={index} className="about__value-card">
              <div className="about__value-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Vídeo */}
        <div className="about__video-cta">
          <p className="about__video-cta-text">
            Quer entender melhor como a Informezz pode transformar sua loja?
          </p>
          <div className="about__video-cta-buttons">
            <button
              type="button"
              className="about__video-btn"
              onClick={() => setIsModalOpen(true)}
              aria-label="Assistir vídeo institucional"
            >
              <span className="about__video-btn-icon">
                <FontAwesomeIcon icon={faPlay} />
              </span>
              <span>Assistir ao Vídeo</span>
            </button>
            <a
              className="about__video-btn about__video-btn--whatsapp"
              href="https://wa.me/5546991107619"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Fale com um especialista pelo WhatsApp"
            >
              <span className="about__video-btn-icon">
                <FontAwesomeIcon icon={faWhatsapp} />
              </span>
              <span>Entre em Contato</span>
            </a>
          </div>
        </div>
      </Section>

      {/* Modal de vídeo */}
      {isModalOpen && (
        <div
          className="about__modal-overlay"
          onClick={(e) => e.target === e.currentTarget && setIsModalOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Vídeo institucional Informezz"
        >
          <div className="about__modal-dialog">
            {/* Botão fechar - fora do player, bem visível */}
            <div className="about__modal-topbar">
              <span className="about__modal-title">Informezz - Sistema para lojas de roupas e calçados</span>
              <button
                type="button"
                className="about__modal-close"
                onClick={() => setIsModalOpen(false)}
                aria-label="Fechar vídeo"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            {/* Player 16:9 */}
            <div className="about__modal-player">
              <ReactPlayer
                url="https://youtu.be/wzY6DGE1TcE"
                width="100%"
                height="100%"
                controls
                playing={isModalOpen}
                playsinline
                config={{
                  youtube: {
                    playerVars: { showinfo: 0, modestbranding: 1 },
                  },
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AboutSection;
